<div>
  <a
    bciWkButtonWithIconRight
    class="comment-btn"
    [iconName]="'comment'"
    (click)="startSurvey()"
  >
    Danos tu opinión
  </a>
</div>
